import {
	useEffect,
	useState
} from 'react'

import {
	useDispatch
} from 'react-redux'

import {
	removeProspect,
	updateProspect,
	createProspect,
	convertProspect,
} from '../slice'

import {
	getChatRoom,
	setShow as setShowMessageCenter
} from '../../MessageCenter/messageCenterSlice'

import {
	useProspectiveClientIds,
	useProspectiveClient,
	useSetProspectViewer,
	useProspectiveClients,
	useProspectViewer,
	useToggleCreator,
	useCreator,
	useHasCRM,
} from '../hooks'

import useS3DirectUpload from '../../../hooks/useS3DirectUpload'

import LocaleDate from '../../LocaleDate/LocaleDate'

import ButtonGroup from 'react-bootstrap/ButtonGroup'
import InputGroup from 'react-bootstrap/InputGroup'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'

import css from '../Styles.module.css'

import Acquisition from './Acquisition'

const Prospect = ({id})=>{
	const hasCRM = useHasCRM()
	const dispatch = useDispatch()
	const {status,prospect} = useProspectiveClient(id)

	const setProspectViewer = useSetProspectViewer()

	const handleRemove = ()=>{
		if (!window.confirm('Are you sure you want to remove this prospect?')) return 
		dispatch(removeProspect(id))
	}

	const handleConvert = ()=>{
		if (!window.confirm('Are you sure you want to convert this prospect to a client?')) return 
		dispatch(convertProspect(id))
	}

	const openChatHandler = () => {
		dispatch(getChatRoom({
			room_id:prospect.private_chat_room_id
		}))
		dispatch(setShowMessageCenter(true))
	} 


	return (
		<div className={css.Prospect}>
			<div className="d-flex justify-content-between flex-wrap">
				<div>
					{Boolean(prospect.profile_pic)&&
						<img 
							src={prospect.profile_pic}
							style={{
								width:'40px',
								height:'40px',
								objectFit:'cover',
								borderRadius:'100px',
								overflow:'hidden',
								marginRight:'8px'
							}}
						/>
					}
					<strong
						onClick={setProspectViewer.bind(null,{show:true,id,mode:'view'})}
						className="text-primary"
						style={{cursor:'pointer'}}
						tabindex={0}
					>
						{Boolean(prospect.user_name)?prospect.user_name:<em>No name provided</em>}
					</strong>
				</div>
				<div>
					<Button 
						onClick={handleRemove}
						size="sm" 
						className="ml-2" 
						variant="outline-danger"
					>
						<i className="fa fa-trash"/>
					</Button>
					<Button 
						onClick={handleConvert}
						size="sm" 
						className="ml-2" 
						variant="outline-primary"
					>
						Convert to Client
					</Button>
					<Button 
						onClick={setProspectViewer.bind(null,{show:true,id,mode:'edit'})}
						size="sm" 
						className="ml-2" 
						variant="outline-primary"
					>
						<i className="fa fa-edit"/>
					</Button>
					{hasCRM&&
						<Button 
							onClick={openChatHandler}
							size="sm" 
							className="ml-2" 
							variant="outline-success"
						>
							<i className="fa fa-comment"/>
						</Button>
					}
				</div>
			</div>
			<div>
				<a href={`mailto:${prospect.user_id}`}>
					<small>
						<i className="fa fa-at mr-1"/>
						{prospect.user_id}
					</small>
				</a>
			</div>
			<Acquisition id={id}/>
			{prospect.pipelines.length>0&&
				<div className="text-info">
					<hr className="my-1"/>
					<small>Active Automations: {prospect.pipelines.join(', ')}</small>
				</div>
			}
		</div>
	)
}

const Creator = ()=>{
	const dispatch = useDispatch()
	const {show} = useCreator()
	const [name,setName] = useState('')
	const [email,setEmail] = useState('')
	const [phone,setPhone] = useState('')
	const [notes,setNotes] = useState('')
	const [pic,setPic] = useState('')

	const {processUpload} = useS3DirectUpload()

	const toggle = useToggleCreator()

	const [saving,setSaving] = useState(false)
	const handleSave = async ()=>{
		setSaving(true)

		const payload = {
			client_email:email,
			name,
			phone,
			acquisition_data:notes
		}

		if (Boolean(pic)) {
			const s3Res = await processUpload(pic)
			payload.profile_pic = s3Res.payload.url
		}

		dispatch(createProspect(payload)).then(()=>{
			setSaving(false)
			setName('')
			setEmail('')
			setPhone('')
			setPic('')
			toggle()
		})
	}

	return (
		<Modal show={show} onHide={toggle}>
			<Modal.Header closeButton>
				Prospect Details
			</Modal.Header>
			<Modal.Body>
				{!Boolean(pic)&&
					<Form.File 
						onChange={e=>{
							setPic(e.target.files[0])
						}}
						custom 
						label="New Profile Pic" 
						id="prospect-profile-pic-input"
					/>
				}
				{Boolean(pic)&&
					<div>
						<img 
							src={URL.createObjectURL(pic)} 
							style={{
								width:'200px',
								height:'200px',
								objectFit:'cover',
								maxWidth:'100%',
								borderRadius:'3000px',
								display:'block',
								margin:'auto'
							}}
						/>
						<Button 
							className="my-2"
							variant="outline-danger"
							onClick={setPic.bind(null,'')}
							block
							size="sm"
						>
							Remove Image
						</Button>
					</div>
				}
				<div>
					<strong>Name</strong>
					<Form.Control 
						onChange={e=>{
							setName(e.target.value)
						}}
						placeholder="name" 
						value={name}
					/>
				</div>
				<div>
					<strong>Email</strong>
					<Form.Control 
						onChange={e=>{
							setEmail(e.target.value)
						}}
						placeholder="email" 
						value={email}
					/>
				</div>
				<div>
					<strong>Phone</strong>
					<Form.Control 
						placeholder="phone" 
						value={phone}
						onChange={e=>{
							setPhone(e.target.value)
						}}
					/>
				</div>
				<div>
					<strong>Notes</strong>
					<Form.Control 
						placeholder="notes" 
						value={notes}
						onChange={e=>{
							setNotes(e.target.value)
						}}
						as="textarea"
						style={{
							minHeight:'300px'
						}}
					/>
				</div>
				<div className="text-right mt-2">
					<Button 
						disabled={saving}
						onClick={handleSave}
						variant="outline-success"
						size="sm"
					>
						Save {saving&&<Spinner animation="border" size="sm"/>}
					</Button>
				</div>
			</Modal.Body>
		</Modal>
	)
}

const Prospects = ()=> {
	const {status,prospects} = useProspectiveClients()
	const toggleCreator = useToggleCreator()
	const [sortBy,setSortBy] = useState('date')
	const [sortOrder,setSortOrder] = useState('desc')

	const sorted = prospects.sort((a,b)=>{
		const multiplier = sortOrder === 'desc' ? -1 : 1
		switch(sortBy){
			case 'date': return a.date_create < b.date_create ? -1*multiplier : multiplier
			case 'name': return a.user_name.toLowerCase() < b.user_name.toLowerCase() ? -1*multiplier : multiplier
		}
	})

	return (
		<div>
			<div className="d-flex mb-3 justify-content-between flex-wrap">
				<InputGroup style={{width:'400px'}} size="sm">
					<Form.Control 
						onChange={e=>{
							setSortBy(e.target.value)
						}}
						value={sortBy}
						as="select"
					>
						<option value="date">
							Sort by Date Acquired
						</option>
						<option value="name">
							Sort by Name
						</option>
					</Form.Control>
					<Form.Control 
						onChange={e=>{
							setSortOrder(e.target.value)
						}}
						value={sortOrder}
						as="select"
					>
						<option value="desc">
							Descending
						</option>
						<option value="asc">
							Ascending
						</option>
					</Form.Control>
				</InputGroup>
				<Button 
					onClick={toggleCreator}
					variant="outline-success" 
					size="sm">
					Add Prospect
				</Button>
			</div>
			{status!=='idle'&&
				<Spinner animation="border"/>
			}
			{sorted.map(({user_id_number})=>(
				<Prospect key={user_id_number} id={user_id_number}/>
			))}
			<Creator/>
		</div>
	)
}

export default Prospects